import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DxToolbarComponent } from 'devextreme-angular/ui/toolbar';
import { IPageTitle } from '../../models/page-title';
import { ApiService } from '../../services/data/api.service';
import { NavMenuService } from '../../services/navigation/navmenu.service'
import { MainDataFactory } from '../../data/factory.mainDataFactory';
import { LoginService } from '../../services/account/login.service';
import { NavigationMenuGroup } from '../../models/navigation/navigation-menu-group.model';
import { SecuritySettingsModel } from '../../models/security/security-settings.model';
import { AppSettingsService } from '../../services/core/app-settings.service';
import { AppService } from '../../services/core/app.service';

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css'],
    providers: [LoginService, MainDataFactory]
})
export class NavMenuComponent implements OnInit {
    @ViewChild(DxToolbarComponent, { static: false }) toolbar: DxToolbarComponent;
    dataSource: NavigationMenuGroup[];
    public isDrawerOpen: boolean = false;
    toolbarItems: any[];
    public pageTitle: IPageTitle;
    public userName: string;
    isLoggedIn: boolean = false;
    public innerWidth: any;
    constructor(public appService: AppService, public navMenuService: NavMenuService, private router: Router
        , private changeDetectorRef: ChangeDetectorRef, private apiService: ApiService, private route: ActivatedRoute
        , public appSettingsService: AppSettingsService
        , private loginService: LoginService, private mainDataFactory: MainDataFactory
        , private titleService: Title) {
        this.setToolbarItems(false);
        this.getCurrentUser(true);
        this.navMenuService.getGroups().subscribe((response: NavigationMenuGroup[]) => { this.dataSource = response });
        router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                if (!this.appService.isFullScreen)
                    this.appService.isFullScreen = false;
                this.apiService.get<IPageTitle>(`api/pagetitle?url=${event.url}`).toPromise().
                    then(response => {
                        this.pageTitle = response;
                        if (this.toolbar)
                            this.toolbar.instance.repaint();
                        this.isDrawerOpen = false;
                        this.titleService.setTitle(this.pageTitle.longTitle);
                    });
            }
            // NavigationEnd        // NavigationCancel         // NavigationError         // RoutesRecognized
        });
        this.mainDataFactory.AuthService.isLoggedIn$.subscribe((isLoggedIn: boolean) =>
            this.onAuthed(isLoggedIn)
        );

    }
    setToolbarItems(loggedInSite: boolean) {
        let routeName = window.location;

        if ((loggedInSite == true) && (routeName.toString().includes('analytics/driver-fatigue-details') == true)) {
            this.toolbarItems = [
                {
                    location: 'center',
                    template: 'title'
                },
                {
                    location: 'after',
                    template: 'branding'
                }
            ];
        }
        else if ((loggedInSite == true) && (this.innerWidth > 1200))  {
            this.toolbarItems = [
                {
                    location: 'before',
                    template: 'hamburger'
                }
                , {
                    location: 'before',
                    template: 'fixedscreen1'
                },
                {
                    location: 'before',
                    template: 'fixedscreen2'
                },
                {
                    location: 'before',
                    template: 'fixedscreen3'
                },
                {
                    location: 'center',
                    template: 'title'
                },
                {
                    location: 'after',
                    template: 'fixedscreen4'
                },
                {
                    location: 'after',
                    template: 'fixedscreen5'
                },
                {
                    location: 'after',
                    template: 'fixedscreen6'
                },
                {
                    location: 'after',
                    template: 'branding'
                }
            ];
        }
        else {
            this.toolbarItems = [
                {
                    location: 'before',
                    template: 'hamburger'
                },
                {
                    location: 'center',
                    template: 'title'
                },
                {
                    location: 'after',
                    template: 'branding'
                }
            ];
        }
    }

    clickFixedScreen(screenNumber: number) {
        if (screenNumber == 1)
            this.router.navigate([this.appSettingsService.fixedScreen1]);
        else if (screenNumber == 2)
            this.router.navigate([this.appSettingsService.fixedScreen2]);
        else if (screenNumber == 3)
            this.router.navigate([this.appSettingsService.fixedScreen3]);
        else if (screenNumber == 4)
            this.router.navigate([this.appSettingsService.fixedScreen4]);
        else if (screenNumber == 5)
            this.router.navigate([this.appSettingsService.fixedScreen5]);
        else if (screenNumber == 6)
            this.router.navigate([this.appSettingsService.fixedScreen6]);
    }
    refreshMenuItems() {
        this.navMenuService.getGroups().subscribe((response: NavigationMenuGroup[]) => { this.dataSource = response });
    }
    refreshMenuItemsLoggedOff() {
        this.navMenuService.getGroupsLoggedOut().subscribe((response: NavigationMenuGroup[]) => { this.dataSource = response });
    }
    menuClick() {
        if (this.navMenuService.showMenu == false)
            alert('inv');
        else {
            this.isDrawerOpen = !this.isDrawerOpen;
            this.changeDetectorRef.detectChanges();
        }
    }
    ngOnInit(): void {
        //TODO: need to subscribe to the login event , see above !!
        this.innerWidth = window.innerWidth;
    }
    onAuthed(loggedIn: boolean) {
        this.getCurrentUser(loggedIn);
        if (loggedIn == true)
            this.refreshMenuItems();
        else
            this.refreshMenuItemsLoggedOff();
    }
    getCurrentUser(updateCurrentUser: boolean) {
        this.userName = "Not Logged In";
        if (updateCurrentUser == false) {
            this.isLoggedIn = false;
            this.setToolbarItems(false);
            return;
        }
        this.loginService.getCurrentUser().subscribe((response) => {
            this.userName = response.userName.toLowerCase();// .substring(0, 15) + '...';
            this.isLoggedIn = true;

            this.loginService.GetIsExcluded(this.userName).subscribe((response) => {
                this.setToolbarItems(!response);
            });
            this.loginService.LogUserLogin(this.userName).subscribe((response) => {

            });

        }, (error) => {

        });



    }
    public signOut() {
        this.mainDataFactory.AuthService.logout().then(() => {
            this.mainDataFactory.StorageService.clear(SecuritySettingsModel.access_token);
            this.userName = "Not Logged In";
            this.router.navigate(['account/login']);
        });
    }
    drawer_closeOnOutsideClick(e: any) {
        return e && e.x && e.y && (e.x > 55 || e.y > 55); //not the top left corner
    }
}
